import { environment } from '../../environments/environment';


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { VoucherTypes } from 'app/models/vouchertype.models';

@Injectable({
  providedIn: 'root'
})
export class TcomprobanteService {


  typecomprobantes: Observable<VoucherTypes[] | any>;

  constructor(private http: HttpClient) { }

  getObtenerTypesComprobantes(): Observable<VoucherTypes | any> {
    return this.http.get(environment.apiUrl + 'voucher-type');
  }


  getTypeComprobanteById(id): Observable<VoucherTypes | any>  {
    return this.http.get(environment.apiUrl + 'voucher-type/' + id);
  }

  // Obtener tipo de comprobante por código específico
  getTypeComprobanteByCode(code: string): Observable<VoucherTypes | any> {
    return this.http.get(environment.apiUrl + 'voucher-type/' + code);
  }

  // Receipt Book Type methods
  createReceiptBookType(receiptBookType: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'receipt-book-type', receiptBookType);
  }

  getReceiptBookTypes(): Observable<any> {
    return this.http.get(environment.apiUrl + 'receipt-book-type');
  }

  getReceiptBookTypeById(id: number): Observable<any> {
    return this.http.get(environment.apiUrl + 'receipt-book-type/' + id);
  }

  updateReceiptBookType(id: number, receiptBookType: any): Observable<any> {
    return this.http.patch(environment.apiUrl + 'receipt-book-type/' + id, receiptBookType);
  }

  deleteReceiptBookType(id: number): Observable<any> {
    return this.http.delete(environment.apiUrl + 'receipt-book-type/' + id);
  }

}
